import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { useAuth } from '../../common/auth';

import './Header.scss';

export default function Header() {
  const { user, logout } = useAuth();
  const history = useHistory();

  return <header id="topnav" className="sticky">
    <div className="container">
      <div>
        <NavLink className="logo" to="/">
          <img src="/images/logo-dark.png" alt="logo" />
        </NavLink>
      </div>
      <div className="nav-button">
        {
          !user && <>
            <NavLink to="/login" activeClassName="active" className='btn btn-secondary mr-1'>Login</NavLink>
            <NavLink to="/" activeClassName="active" exact className='btn btn-secondary'>Sign Up</NavLink>
          </>
        }
        {
          user && <>
            <NavLink to="/status" exact activeClassName="active" className="btn btn-secondary mr-1">Status</NavLink>
            <button onClick={() => { logout(); history.push('/login') }} className="btn btn-secondary">Logout</button>
          </>
        }
      </div>
    </div>
  </header>
}